module.exports = __webpack_public_path__ + "media/gallery/photo09-31a07b56.webp";